export const soundTypes = {
    soundGet: '[Sound] gets all sounds for the animal',
    soundSelect: '[Sound] randomly select sounds to play',

    soundAddQueue: '[Sound] adds a new song to the queue',
    soundRemoveQueue: '[Sound] removes the next song to the queue',
}